import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../../localization'
import { ComlogData } from '../../../types/monitoring'
import useStyles from './styles/MonitoringFormListTableHead.styles'

interface MonitoringFormListTableHeadDesktopProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      comLogs: ComlogData
    }>
  >
}

const MonitoringFormListTableHeadDesktop: React.FC<
  MonitoringFormListTableHeadDesktopProps
> = ({ refetch }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Date')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('User IP')}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate('Request Method')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Endpoint Name')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Endpoint URL')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Status')}</Typography>
      </div>
      <div>
        <IconButton
          onClick={() => {
            refetch()
          }}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default MonitoringFormListTableHeadDesktop
